import React, { useEffect } from "react";
import clsx from "classnames";
import { useDispatch, useSelector } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { container } from "assets/jss/material-kit-pro-react.jsx";

import BlogCard from "components/BlogCard";

import { fetchBlogs } from "actions/blogAction";

const slider = {
  top: "calc(50% - 20px)",
  position: "absolute",
  background: "rgb(240, 240, 240)",
  borderRadius: "20px",
  width: "40px",
  height: "40px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "18px",
  zIndex: 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  userSelect: "none",
};

const blogCount = 6;

const useStyles = makeStyles(theme => ({
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
  },
  marginTop: {
    marginTop: "180px",
  },
  title: {
    margin: "100px 0",
  },
  blogContainer: {
    paddingBottom: "60px",
  },
  textCenter: {
    textAlign: "center",
  },
  next: {
    ...slider,
    boxShadow: theme.shadows[2],
    right: "16px",
  },
  prev: {
    ...slider,
    boxShadow: theme.shadows[2],
    left: "16px",
    transform: "scale(-1)",
  },
}));

const Blogs = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [page, setPage] = React.useState({ start: 1, end: 3, direction: 0 });

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    dispatch(fetchBlogs(0, blogCount));
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  const paginate = direction => {
    setPage(({ start, end }) => ({ start: start + direction, end: end + direction, direction }));
  };

  const blogs = useSelector(state => state?.blog?.blogs);
  let blogList = Object.keys(blogs)
    .map(idx => blogs[idx])
    .filter(blogs => blogs?.products?.includes("optafloor"))
    .sort((a, b) => b.id - a.id)
    .slice(page.start - 1, page.end);

  return (
    <div className={clsx(classes.marginTop)}>
      <div className={classes.title}>
        <Typography className={classes.textCenter} variant="h3">
          Blogs
        </Typography>
      </div>

      <div className={clsx(classes.container, classes.blogContainer)}>
        <Grid container spacing={4}>
          {blogList.map(blog => (
            <Grid item key={blog.id} xs={12} sm={4}>
              <BlogCard blog={blog} footer={false} characterCount={170} />
            </Grid>
          ))}
        </Grid>
        {page.start > 1 && (
          <div className={classes.prev} onClick={() => paginate(-1)}>
            {"‣"}
          </div>
        )}
        {page.end < blogCount && (
          <div className={classes.next} onClick={() => paginate(1)}>
            {"‣"}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogs;
